export const LABEL_COLORS = ['#d93025', '#e37400', '#f9ab00', '#188038', '#0b8043', '#005040', '#3b82c4', '#9334e6', '#c2185b', '#5f6368']
